<template>
  <div>
    <div class="Ebanner">
      <!-- 麵包屑 開始-->
      <div class="bread">
        <p v-html="'HOME &nbsp; / &nbsp;&nbsp; JEWELRY &nbsp; / &nbsp; EARRINGS'"></p>
      </div>
      <!-- 麵包屑 結束-->
      <img :src="earringsBanner" alt="" class="earrings-banner">
      <div class="EbannerText">
        <h2>EARRINGS</h2>
        <div class="TextZone">
          <p>I believe the perfect piece of jewellery is a personal one. It’s a piece that is imbued with hopefully bringing emotive connections for future generations to come.</p>
        </div>
      </div>
        <!--篩選器開始-->
        <div class="filterzone">
          <div class="sortOrFilter-wrap">
            <Button @click="sortActive" id="sortBtn">SORT BY</Button>
            <Button @click="filterActive" id="filterBtn">FILTER</Button>
          </div>
          <!--排序sort開始-->
          <transition name="sort">
            <div class="sort-box" v-if="isSortOpen">
              <RadioGroup v-model="sort">
                <Button ghost @click="sortClose">
                  <div class="cross"></div>
                </Button>
                <Radio label="popularity">
                  <span>Popularity</span>
                </Radio>
                <Radio label="newness">
                  <span>Newness</span>
                </Radio>
                <Radio label="priceLow">
                  <span>Price: Low to high</span>
                </Radio>
                <Radio label="priceHigh">
                  <span>Price: High to low</span>
                </Radio>
              </RadioGroup>
              <Button class="apply-btn" @click="sortApply">APPLY</Button>
            </div>
          </transition>
          <!--排序sort結束-->
          <div class="line"></div>
          <!--篩選器filter開始-->
          <transition name="filter">
            <div class="filter-box" v-if="isFilterOpen">
              <RadioGroup v-model="filter">
                <Button ghost @click="filterClose">
                  <div class="cross"></div>
                </Button>
                <Row type="flex" justify="space-between">
                  <Col span="10" offset="1">
                    <h4>Color</h4>
                    <div class="filter-wrap">
                      <Radio label="blue">
                        <span>Blue</span>
                      </Radio>
                      <Radio label="yellow">
                        <span>Yellow</span>
                      </Radio>
                      <Radio label="white">
                        <span>White</span>
                      </Radio>
                      <Radio label="red">
                        <span>Red</span>
                      </Radio>
                      <Radio label="grey">
                        <span>Grey</span>
                      </Radio>
                      <Radio label="allColor">
                        <span>All</span>
                      </Radio>
                    </div>
                  </Col>
                  <Col span="10" offset="1">
                    <h4>Material</h4>
                    <Radio label="turquoise">
                      <span>Turquoise</span>
                    </Radio>
                    <Radio label="gold">
                      <span>Gold</span>
                    </Radio>
                    <Radio label="kyanite">
                      <span>Kyanite</span>
                    </Radio>
                    <Radio label="opal">
                      <span>Opal</span>
                    </Radio>
                    <Radio label="ruby">
                      <span>Ruby</span>
                    </Radio>
                    <Radio label="allMaterial">
                      <span>All</span>
                    </Radio>
                  </Col>
                </Row>
              </RadioGroup>
              <Button class="apply-btn" @click="filterApply">APPLY</Button>
            </div>
          </transition>
          <!--篩選器filter結束-->
        </div>
        <!--篩選器結束-->
    </div>
    <!--商品區 開始-->
    <div class="earrings_product">
      <Row type="flex" justify="start">
        <Col v-for="(item, index) in productListForShow" :key="index" :xs="12" :sm="12" :md="6">
          <router-link :to="item.path">
            <img class="bigimg" :src="item.img" alt="">
          </router-link>
          <div class="icon">
            <img :src="iconHeart" alt="" @click="addFavorite(item)" :id="`icon-heart-${index}`">
            <img :src="iconCart" alt="" @click="addCart(item)" :id="`icon-cart-${index}`">
          </div>
          <div class="item_text">
            <h4>{{item.text}}</h4>
            <p>{{`$${formatNum(item.price)}`}}</p>
          </div>
        </Col>
      </Row>
    </div>
    <!--商品區 結束-->
  </div>
</template>

<script>
import earringsBanner from '@/assets/pc/earrings/banner.jpg'
import iconHeart from '@/assets/pc/earrings/hover_icon_heart02.png'
import iconCart from '@/assets/pc/earrings/hover_icon_cart02.png'
import { productList } from '@/util/list'
import { formatNum } from '@/util/number'
import { mapState } from 'vuex'

export default {
  mounted () {
    this.renderColor()
  },
  computed: {
    ...mapState({
      favoriteList: state => state.product.favoriteList,
      cartList: state => state.product.cartList
    })
  },
  data () {
    return {
      earringsBanner,
      sort: '',
      filter: '',
      isSortOpen: false,
      isFilterOpen: false,
      productList,
      productListForShow: [...productList],
      iconHeart,
      iconCart,
      formatNum
    }
  },
  methods: {
    // 處理篩選器彈窗顯示 開始
    sortActive () {
      this.isFilterOpen = false
      this.isSortOpen = true
      document.getElementById('sortBtn').classList.add('btn-active')
      document.getElementById('filterBtn').classList.remove('btn-active')
    },
    filterActive () {
      this.isSortOpen = false
      this.isFilterOpen = true
      document.getElementById('filterBtn').classList.add('btn-active')
      document.getElementById('sortBtn').classList.remove('btn-active')
    },
    sortClose () {
      this.isSortOpen = false
      this.sort = ''
      document.getElementById('sortBtn').classList.remove('btn-active')
    },
    filterClose () {
      this.isFilterOpen = false
      this.filter = ''
      document.getElementById('filterBtn').classList.remove('btn-active')
    },
    // 處理篩選器彈窗顯示 結束
    // sort排序 開始
    sortApply () {
      const sortList = {
        popularity: this.popularitySort,
        newness: this.newnessSort,
        priceLow: this.priceLowSort,
        priceHigh: this.priceHighSort
      }
      sortList[this.sort]()
      this.renderAfterSort()
    },
    popularitySort () {
      this.productListForShow.sort((a, b) => {
        return a.soldOut - b.soldOut
      })
    },
    newnessSort () {
      this.productListForShow.sort((a, b) => {
        return +new Date(a.date) - +new Date(b.date)
      })
    },
    priceLowSort () {
      this.productListForShow.sort((a, b) => {
        return a.price - b.price
      })
    },
    priceHighSort () {
      this.productListForShow.sort((a, b) => {
        return b.price - a.price
      })
    },
    // sort排序 結束
    // filter篩選 開始
    filterApply () {
      this.productListForShow = [...productList]
      const filterList = {
        blue: this.colorFilter,
        yellow: this.colorFilter,
        white: this.colorFilter,
        red: this.colorFilter,
        grey: this.colorFilter,
        allColor: this.colorFilter,
        turquoise: this.materialFilter,
        gold: this.materialFilter,
        kyanite: this.materialFilter,
        opal: this.materialFilter,
        ruby: this.materialFilter,
        allMaterial: this.materialFilter
      }
      filterList[this.filter](this.filter)
    },
    colorFilter (val) {
      const temProductList = [...this.productList]
      if (val === 'allColor') return
      this.productListForShow = temProductList.filter(item => item.color === val)
    },
    materialFilter (val) {
      const temProductList = [...this.productList]
      if (val === 'allMaterial') return
      this.productListForShow = temProductList.filter(item => item.material === val)
    },
    // filter篩選 結束
    // 我的最愛 開始
    addFavorite (item) {
      const index = this.favoriteList.findIndex(favoriteItem => favoriteItem.id === item.id)
      if (item.favoriteStatus === 0 && index === -1) {
        document.getElementById(`icon-heart-${item.id}`).classList.add('icon-color')
        item.favoriteStatus = 1
        this.favoriteList.push(item)
      } else {
        document.getElementById(`icon-heart-${item.id}`).classList.remove('icon-color')
        item.favoriteStatus = 0
        this.favoriteList.splice(index, 1)
      }
      this.$store.dispatch('addFavoriteList', this.favoriteList)
    },
    renderColor () {
      this.favoriteList.forEach(item => {
        if (item.favoriteStatus === 1) {
          document.getElementById(`icon-heart-${item.id}`).classList.add('icon-color')
        }
      })
      this.cartList.forEach(item => {
        if (item.cartStatus === 1) {
          document.getElementById(`icon-cart-${item.id}`).classList.add('icon-color')
        }
      })
    },
    renderAfterSort () {
      this.productListForShow.forEach(item => {
        if (item.cartStatus === 1) {
          document.getElementById(`icon-cart-${item.id}`).classList.add('icon-color')
        }
      })
    },
    // 我的最愛 結束
    // 購物車 開始
    addCart (item) {
      const index = this.cartList.findIndex(cartItem => cartItem.id === item.id)
      if (item.cartStatus === 0 && index === -1) {
        document.getElementById(`icon-cart-${item.id}`).classList.add('icon-color')
        item.cartStatus = 1
        this.cartList.push(item)
      } else {
        document.getElementById(`icon-cart-${item.id}`).classList.remove('icon-color')
        item.cartStatus = 0
        this.cartList.splice(index, 1)
      }
      this.$store.dispatch('addCartList', this.cartList)
    }
    // 購物車 結束
  }
}
</script>

<style>
.sort-enter-active,
.filter-enter-active {
  transition: all .3s linear;
}
.sort-leave-active,
.filter-leave-active {
  transition: all .1s linear;
}
.sort-enter,
.filter-enter {
  opacity: 0;
}
.sort-leave-to,
.filter-leave-to {
  opacity: 0;
}
</style>
